import CssBaseline from "@material-ui/core/CssBaseline";
import { makeStyles } from "@material-ui/styles";
import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Redirect,
  Route,
  Switch,
} from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import HomePage from "./components/HomePage/HomePage";
import Services from "./components/Services/Services";
import OurWork from "./components/OurWork/OurWork";
import Testimonials from "./components/Testimonials/Testimonials";
import ContactUs from "./components/ContactUs/ContactUs";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    backgroundImage: `url(${
      process.env.PUBLIC_URL + "/assets/background13.jpg"
    } )`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
  },
}));

function App() {
  const classes = useStyles();

  const [currPage, setCurrPage] = useState("Home");

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Router>
        <Header currPage={currPage} setCurrPage={setCurrPage} />
        <Switch>
          <Redirect exact from="/" to="/home" />
          <Route path="/contact-us">
            <ContactUs setCurrPage={setCurrPage} />
          </Route>
          <Route path="/testimonials">
            <Testimonials setCurrPage={setCurrPage} />
          </Route>
          <Route path="/services">
            <Services setCurrPage={setCurrPage} />
          </Route>
          <Route path="/our-work">
            <OurWork setCurrPage={setCurrPage} />
          </Route>
          <Route path="/home">
            <HomePage setCurrPage={setCurrPage} />
          </Route>
        </Switch>
      </Router>
    </div>
  );
}

export default App;
